/**
 * @Author liyaoshi liyaoshi@sohu-inc.com
 * @Description 通用广告处理
 */

import MptcfeWapAd from "mptcfe-wap-ad";
import adSspExposure from "../sspRequest/adExposure";
import videoTxtAd from "../components/videoTxtAd.vue"
import { getOdinData } from "@/js/request/odinRequest";
import { printStack } from "@/utils/consoleUtil";

const AdBannerBig = MptcfeWapAd.Components.AdBannerBig;
const AdThreePic = MptcfeWapAd.Components.AdThreePic;
const AdGraphicMixOrigin = MptcfeWapAd.Components.AdGraphicMixOrigin;
const AdFeedText = MptcfeWapAd.Components.AdFeedText;
const AdShopWindow = MptcfeWapAd.Components.shopwindow
const AdGenerator = MptcfeWapAd.AdGenerator

// 普通文章页信息流
export const commonFeedAd = (sspArr, resourceId, setStateFun) => {
    // 获取位置信息
    let location = "";
    // 获取广告总数量
    let sspLen = sspArr.length;
    
    const templateMap = {
        XPS: {
            text: AdFeedText,
            threePic: AdThreePic,
            bigBanner: AdBannerBig,
            graphicMix: AdGraphicMixOrigin,
            shopwindow: AdShopWindow,
            default: AdGraphicMixOrigin,
        },
        SOHUZH: {
            VideoTxt: videoTxtAd,
            text: AdFeedText,
            threePic: AdThreePic,
            bigBanner: AdBannerBig,
            graphicMix: AdGraphicMixOrigin,
            shopwindow: AdShopWindow,
        }
    }
    sspArr.forEach((item) => {
        location = `fd-d.${item.location}`;
        const adType = item && item.adType
        const template = templateMap[adType]
        new AdGenerator({
            data: item,
            resourceId: resourceId,
            desParams: {
                containerStyle: {
                    "border-bottom": "1px solid #f0f0f0",
                    padding: "12px 0",
                },
            },
            location: location,
            component: template,
            isMulti: true,
            success: function (adDom) {
                //需同父级元素一起选定，避免选到页面中其余的feed流
                $(".feed-list-new-container .feed-list-scoped")
                    .find("[data-lca='" + item.location + "']")
                    .append(adSspExposure(adDom, item));
                // 如果广告有回调返回则递减,直到等于0时打码
                sspLen -= 1;
                if (sspLen === 0) {
                    setStateFun();
                }
            },
            successEmpty: () => {
                sspLen -= 1;
                noAdHandler(item.location, sspLen, setStateFun);
            },
            timeout: () => {
                sspLen -= 1;
                noAdHandler(item.location, sspLen, setStateFun);
            },
            error: () => {
                sspLen -= 1;
                noAdHandler(item.location, sspLen, setStateFun);
            },
        });
    });
};

// 无广告处理
const noAdHandler = (location, sspLen, setStateFun) => {
    console.log('wap文章推荐流',location,'空广告')
    // 移除占位节点
    $(".feed-list-new-container .feed-list-scoped")
        .find("[data-lca='" + location + "']")
        .remove();
    // 如果广告有回调返回则递减,直到等于0时打码
    if (sspLen === 0) {
        setStateFun();
    }
};

/**
 * @description 通用独立广告位请求和渲染，依据广告配置请求广告并渲染广告
 * @param {{spmCCode: string, resourceId: string, posCode: string, rule: number, fixArray: Array<number>, el: string}} adConfig 广告配置
 */
export const renderSingleAd = async (adConfig) => {
    if(!adConfig) {
        const stack = printStack()
        console.log('无广告配置，请检查函数调用传参', stack)
        return
    }
    const { resourceId, spmCCode, posCode, rule, fixArray, el } = adConfig
    if(!el){
        const stack = printStack()
        console.log('无广告锚点，请检查函数调用传参', stack)
        return
    }
    const param = {
        resourceId,
        spmCCode,
        adInfo: {
            posCode,
            rule,
            fixArray
        },
        isSingleAd: true
    }
    try {
        const data = await getOdinData(param)
        const list = data?.list
        const adData = list?.[0]?.resourceData
        if(!adData) return
        new AdGenerator({
            data: adData,
            location: spmCCode,
            resourceId: resourceId,
            success: (adDom) => {
                adDom && document.querySelector(el)?.appendChild(adDom)
            }
        })
    } catch (error) {
        console.log(spmCCode, '广告异常', error)
    }
}
